import { Component, OnInit } from '@angular/core';
import { Products } from 'src/app/model/products.model';
import { ProductService } from 'src/app/services/product/product.service';
import { Productcategory } from 'src/app/model/productcategory.model';
import { OrderService } from 'src/app/services/order/order.service';
import { Router, ActivatedRoute } from '@angular/router';


@Component({
  selector: 'app-editorderitems',
  templateUrl: './editorderitems.component.html',
  styleUrls: ['./editorderitems.component.css']
})
export class EditorderitemsComponent implements OnInit {

  //product: Products;
  product: any;
  category: Productcategory;
  cartItems: any;
  orderNo: string;

  //product: any;
  productCopy: any;
  filteredProduct: any;

  constructor(private productServices: ProductService, private orderServices: OrderService,
    private route: ActivatedRoute, private router: Router) {

    this.orderNo = this.route.snapshot.params.ordernumber;

    this.productServices.getProductCategory().subscribe(
      (data: any) => {
        this.category = data;
        console.log(this.category);
      }
    )

  }

  ngOnInit() {
    this.productServices.getProductList().subscribe(
      (data: any) => {
        this.product = data;
        this.productCopy = data;
        console.log(this.product);
      }
    )
    //this.getCartItems();
  }

  addtoorder(productId: number) {
    this.orderServices.addItemsToOrder(this.orderNo, productId).subscribe(
      (data: any) => {
        if (data == true) {
          this.router.navigate(['/editorder', this.orderNo]);
        }
        else {
          alert("already added");
        }
      });
  }

  onSelectCategory(catid) {
    this.filteredProduct = this.productCopy.filter(x => x.productCategoryId == catid);
    this.product = this.filteredProduct;
  }

  backScreen()
  {
    window.history.back();
  }

  filterProductList(keyword)
  {
    this.productServices.filterProduct(keyword).subscribe(
      (data) => {
        this.product = data;
        console.log(data);
      }
    );
    //alert(keyword);
  }

  // getCartItems() {
  //   this.orderServices.getUserCartItems().subscribe(
  //     (data: any) => {
  //       this.cartItems = data;
  //       console.log(this.cartItems);
  //     }
  //   )
  // }

}
